import { PERMISSIONS_OPTIONS_VALUE } from 'constants/team-members';

const { EDITOR, VIEW_ONLY } = PERMISSIONS_OPTIONS_VALUE;

export const STORE_DESIGN_PERMISSIONS = {
  [VIEW_ONLY]: {
    HIDE_CUSTOMIZE_THEME: true,
    HIDE_SELECT_THEME: true
  },
  [EDITOR]: {
    HIDE_SELECT_THEME: true
  }
};
